<script>
import { ElTable, ElTableColumn, ElPagination, ElLoading } from 'element-plus';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import { ref, computed } from 'vue'

export default {
  components: {
    ElTable,
    ElTableColumn,
    ElPagination,
    Spinner
  },
  setup() {
    // 列表数据
    const tableData = ref([])
    // 当前页
    const currentPage = ref(1)
    // 每页显示条数
    const pageSize = ref(2)
    // 总数据条数
    const total = ref(0)
    // 是否加载中
    const loading = ref(true)

    // 计算暗黑模式状态
    const isDarkMode = computed(() => {
      console.info(document.body.classList.contains('dark'), "============", document.body.classList)
      return document.body.classList.contains('dark')
    });

    return {
      tableData,
      currentPage,
      pageSize,
      total,
      loading,
      isDarkMode, // 默认值
    }
  },
  data() {
    return {}
  },
  mounted() {
    // this.fetchAccountDetails();
    this.fetchProducts()
  },
  methods: {
    async fetchProducts() {
      console.info(this.loading, "==========fetchProducts============")
      this.loading = true // 开始加载
      try {
        const productData = await this.$store.dispatch('accounts/getShopifyProducts');
        if (productData?.code != 200) {
          useAlert(productData?.message);
          return
        }
        this.tableData = productData?.data?.items || []
        this.total = productData.total
      } catch (error) {
        console.error("获取数据失败:", error)
      } finally {
        this.loading = false // 结束加载
      }
    },
    async handleSizeChange(size) {
      await this.fetchProducts() // 重新请求数据
      this.pageSize = size
    },
    async handleCurrentChange(page) {
      await this.fetchProducts() // 重新请求数据
      this.currentPage = page
    },
    headerRowStyle() {
      return this.isDarkMode ? { backgroundColor: 'rgb(39, 42, 45)', color: 'white' } : { backgroundColor: 'white', color: 'black' };
    }
  }
}
</script>

<template>
  <div class="flex flex-col justify-between flex-1 h-full m-0 overflow-auto bg-n-background">
    <div class="w-full">
      <div
        v-if="loading"
        class="flex items-center justify-center py-10 text-n-slate-11"
      >
        <Spinner />
      </div>
      <ElTable v-else :data="this.tableData" v-loading="this.loading" :header-cell-style="headerRowStyle" :header-row-style="headerRowStyle" :row-style="headerRowStyle" :style="{'background-color': isDarkMode ? 'rgb(39, 42, 45)' : '#fff'}" style="width: 100%">
        <ElTableColumn label="Image" width="180">
          <template #default="{ row }">
            <img :src="row.imageSrc" alt="Product Image" style="width: 50px; height: 50px; border-radius: 5px;" />
          </template>
        </ElTableColumn>
        <ElTableColumn prop="title" label="Title" width="180" />
        <ElTableColumn prop="status" label="Status" width="180" />
        <ElTableColumn prop="priceRange" label="Price" width="180" />
        <ElTableColumn prop="publishedAt" label="PublishedAt(UTC)" />
        <ElTableColumn prop="createdAt" label="CreatedAt(UTC)" />
      </ElTable>

      <!-- 分页组件 -->
      <!-- <div class="pagination-container">
        <ElPagination
          v-model:current-page="this.currentPage"
          v-model:page-size="this.pageSize"
          :total="this.total"
          layout="prev, pager, next"
          @size-change="this.handleSizeChange"
          @current-change="this.handleCurrentChange"
        />
      </div> -->
    </div>
  </div>
</template>

<style lang="scss">

::v-deep .el-table .el-table__row th:hover {
  background-color: none;
}
.pagination-container {
  display: flex;
  justify-content: flex-end; // 右对齐
  padding: 16px; // 增加间距
}
</style>